/**
 * D_ : 출발일보기
 * L_ : 상품리스트
 */

/** ```
 *  상품리스트 필터 순서 보정
 * "outStartDateList" // 출발 일정 월, 날짜,
 * "wdayList" // 출발 일정 요일,
 * "outDeprtFgList" // 출발 시간,
 * "outCityDiviNm" // 출발지(공항),
 * "evDayCntList" // 여행기간,
 * "minPrice" // 최소금액,
 * "maxPrice" // 최대금액,
 * "airCd" // 이용교통,
 * "goodsFeaturesList" // 상품특징,
 * "goodsPromotion" // 프로모션,
 * "goodsTmember" // 여행구성원,
 * "goodsNm" // 상품 상세 검색,
 ``` */
const L_SHOW_KEYS = [
	"outStartDateList" /* 출발 일정 월, 날짜 */,
	"wdayList" /* 출발 일정 요일*/,
	"outDeprtFgList" /* 출발 시간 */,
	"outCityDiviNm" /* 출발지(공항) */,
	"evDayCntList" /* 여행기간 */,
	"minPrice" /* 최소금액 */,
	"maxPrice" /* 최대금액 */,
	"airCd" /* 이용교통 */,
	"goodsFeaturesList" /* 상품특징 */,
	"goodsPromotion" /* 프로모션 */,
	"goodsTmember" /* 여행구성원 */,
	"goodsNm" /* 상품 상세 검색 */,
];

/** ```
 * 출발일 보기에서 보여줄 필터
 * "outStartDt" // 출발 일자 ,
 * "wdayList" // 출발 일정 요일,
 * "outDeprtFgList" // 출발 시간 ,
 * "outCityDiviNm" // 출발지(공항) ,
 * "evDayCntList" // 여행기간 ,
 * "minPrice" // 최소금액 ,
 * "maxPrice" // 최대금액 ,
 ``` */
const D_SHOW_KEYS = [
	// "outStartDateList" /* 출발 일정 월, 날짜 */,
	"outStartMonth" /* 출발월 */,
	"outStartDt" /* 출발 일자 */,
	"wdayList" /* 출발 일정 요일*/,
	"outDeprtFgList" /* 출발 시간 */,
	"outCityDiviNm" /* 출발지(공항) */,
	"evDayCntList" /* 여행기간 */,
	"minPrice" /* 최소금액 */,
	"maxPrice" /* 최대금액 */,
];

/** ```
 * 출발일 보기에서 전체삭제 제외 필터
 * "isEvReserve", // 예약가능
 * "isEvConfirm", // 출발확정
 * "trCompanySnm", // 교통편
 * "accomSeq", // 옵션
 ``` */
const D_DELETE_EXCLUDE_KEYS = [
	"isEvReserve", // 예약가능
	"isEvConfirm", // 출발확정
	"trCompanySnm", // 교통편
	"accomSeq", // 옵션
];

/** ```
 * 출발일 보기에서 사용하지 않는 필터
 * "outStartMonth", // 출발 월
 * "goodsNm", // 상품명
 * "goodsFeaturesList", // 상품특징
 * "goodsPromotion", // 프로모션
 * "goodsTmember", // 여행구성원
 * "airCd", // 리스트에서 선택한 교통편
 * "dspSid",
``` */
const D_EXCLUDE_KEYS = [
	// "outStartMonth", // 출발 월
	"goodsNm", // 상품명
	"goodsFeaturesList", // 상품특징
	"goodsPromotion", // 프로모션
	"goodsTmember", // 여행구성원
	"airCd", // 리스트에서 선택한 교통편
	"dspSid",
];

export {D_DELETE_EXCLUDE_KEYS, D_EXCLUDE_KEYS, D_SHOW_KEYS, L_SHOW_KEYS};
